import { TabIndicatorProps } from '@v2/components/tabs/AnimatedTabs/types';
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { cn } from '@gettactic/helpers';

export const TabIndicator: React.FC<TabIndicatorProps> = ({
  tabs,
  activeTab,
  tabStyle,
  containerRef
}) => {
  const [dimensions, setDimensions] = useState({
    width: 0,
    left: 0,
    top: 0,
    height: 0
  });

  useEffect(() => {
    const updateDimensions = () => {
      if (!containerRef.current) return;

      const tabElements = containerRef.current.querySelectorAll('[role="tab"]');
      const activeTabElement = Array.from(tabElements).find(
        (tab) => tab.getAttribute('data-state') === 'active'
      );

      if (!activeTabElement) return;

      const { width, height, left, top } =
        activeTabElement.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      setDimensions({
        width,
        height,
        left: left - containerRect.left,
        top: top - containerRect.top
      });
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, [activeTab, containerRef, tabs]);

  if (tabStyle === 'pills' || tabStyle === 'boxed') {
    return null;
  }

  return (
    <motion.div
      className={cn(
        'absolute bg-primary',
        tabStyle === 'underline' && 'bottom-0 h-0.5',
        tabStyle === 'line' && 'bottom-0 h-0.5'
      )}
      animate={{
        width: dimensions.width,
        left: dimensions.left,
        opacity: 1
      }}
      initial={false}
      transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30
      }}
    />
  );
};
